import React from 'react';
import { Icon, Text, TextProps } from '@perch-labs/shrike';
import { copyFor } from 'config';
import { WarningContainer } from './heading-and-text.style';

export type Tag = Pick<TextProps, 'tag'>['tag'];

const getCopy = copyFor('settings.utilitySync');
interface Props {
  heading?: string | React.ReactNode;
  text?: string; // React.ReactNode breaks styles for no-translate spans
  headingTag?: Tag;
  warning?: string | null;
  notranslate?: boolean;
}

export const HeadingAndText = (props: Props) => {
  const { heading, text, headingTag, warning, notranslate } = props;

  const displayHeading = () => {
    if (typeof heading === 'string' && headingTag) {
      return (
        <Text tag={headingTag} textStyle="heading500">
          {heading}
        </Text>
      );
    } else if (typeof heading === 'string') {
      return (
        <Text tag="h2" textStyle="heading500">
          {heading}
        </Text>
      );
    } else {
      return heading;
    }
  };

  const displayText = (
    <Text
      className={notranslate ? 'notranslate' : ''}
      color="secondary"
      margin={{ top: '8px' }}
      textStyle="paragraph500"
    >
      {text}
    </Text>
  );

  const displayWarning = (
    <WarningContainer>
      <Icon
        aria-label={getCopy('warningIconLabel')}
        margin={{ top: '8px' }}
        icon="ExclamationCircleInverted"
        color="errorBright"
      />
      <Text
        color="error"
        margin={{ top: '8px', left: '8px' }}
        textStyle="paragraph400"
      >
        {warning}
      </Text>
    </WarningContainer>
  );

  return (
    <div>
      {!!heading && displayHeading()}
      {text && displayText}
      {warning && displayWarning}
    </div>
  );
};
